import React, { useState, useEffect } from 'react';
import { navigate } from '@reach/router';
import { useEmailValidation } from '../../hooks/isEmailValid';

export default function BtnVentas() {

    const isEmailValid = useEmailValidation();

    return isEmailValid ? (
        <div className="item-menu ">
                <button className="play-button hidden lg:block" onClick={() => navigate('/ventas')}>
                    Ventas
                </button>
        </div>
    ) : (
        <div></div>
    );
}
